import { useMutation } from 'react-query'
import request from '../../../request'
import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import { queryClient } from '../../../queryClient'

export const useRunSourceFetch = () => {
  const dealership = useDealership()
  return useMutation(
    ({ customer_source_id }: { customer_source_id: number }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/sources/${customer_source_id}/run`,
        method: 'POST',
      }),
    {
      onMutate: async ({ customer_source_id }) => {
        await queryClient.cancelQueries(['customerSources', dealership?.id])
        const previousCustomerSources = queryClient.getQueriesData([
          'customerSources',
          dealership?.id,
        ])
        previousCustomerSources.map(([queryKey, data]) => {
          queryClient.setQueryData(queryKey, (old: any) => {
            return {
              ...old,
              data: old?.data?.map((d: any) => {
                if (d.id === customer_source_id) {
                  return {
                    ...d,
                    run_status: 'locked',
                  }
                }
                return d
              }),
            }
          })
        })

        return { previousCustomerSources }
      },
    },
  )
}
